import { t } from "@lingui/core/macro";

import {
  getSquarePaymentErrorMessage,
  normalizeSquarePaymentErrorCode,
} from "@whoosh/utilities/src/Square/squareErrorMessages";

export class CardEntryError extends Error {
  constructor(message: string, readonly canRetryInForm: boolean) {
    super(message);
    this.name = "CardEntryError";
  }
}

export const knownCardSaveError = (
  code?: string | null
): CardEntryError | undefined => {
  const normalized = normalizeSquarePaymentErrorCode(code);
  if (normalized === "CARD_TOKEN_USED" || normalized === "CARD_TOKEN_EXPIRED") {
    return new CardEntryError(
      t`We couldn’t add this card. Please enter the card details again.`,
      true
    );
  }
  const message = getSquarePaymentErrorMessage(normalized);
  return message ? new CardEntryError(message, true) : undefined;
};

export const cardSaveRejected = (code?: string | null) =>
  knownCardSaveError(code) ??
  new CardEntryError(
    t`We couldn’t add this card. Check the card details or use another card.`,
    true
  );

export const cardSaveUnconfirmed = () =>
  new CardEntryError(
    t`We couldn’t confirm whether your card was added. Check your payment methods before trying again.`,
    false
  );

export const getCardEntryError = (error: unknown): CardEntryError =>
  error instanceof CardEntryError ? error : cardSaveUnconfirmed();
